import { calculateAge } from './helpers';

const getCurrentCoverage = (coverageAditional) => coverageAditional.map((el) => ({
  codGrupoCobertura: el.codPlan,
  tipoAsegurado: el.insuredType,
  cobertura: el.coverage,
}));

export const getRequestPlansQuote = (params) => {
  const {
    leadData,
    client,
  } = params;

  return {
    ideLead: leadData.idLead || 1,
    tipoCotizacion: 1,
    detalleContacto: {
      tipoDocumento: Number(client.tipoDocumento) === 4 ? 3 : 2,
      numeroDocumento: client.numeroDocumento,
      correo: 'example@gmail.com',
      tipoAsegurado: 'titular',
      celular: client.telefono,
      edad: calculateAge(client.fechaNacimiento),
      indContactoDespues: 'NO',
      indPoliticaDatosPersonales: 'SI',
    },
    asegurado: [
      {
        nombre: client.nombres,
        tipoDocumento: Number(client.tipoDocumento) === 4 ? 3 : 2,
        numeroDocumento: client.numeroDocumento,
        tipoAsegurado: 'titular',
        correo: 'example@gmail.com',
        celular: client.telefono,
        edad: calculateAge(client.fechaNacimiento),
      },
    ],
  };
};

export const getRequestQuoteFlex = (paramsRequestQuoteFlex) => {
  const {
    planSelected,
    leadData,
    client,
    coverageAditional,
    birthdate,
    mail,
  } = paramsRequestQuoteFlex;

  return {
    codPlan: planSelected.codPlan,
    ideLead: leadData.idLead || 1,
    grupoCobertura: getCurrentCoverage(coverageAditional),
    tipoCotizacion: 1,
    detalleContacto: {
      nombre: client.nombres,
      tipoDocumento: client.tipoDocumento === 4 ? 3 : 2,
      numeroDocumento: client.numeroDocumento,
      correo: mail,
      tipoAsegurado: 'titular',
      celular: client.telefono,
      edad: calculateAge(`${birthdate.year}-${birthdate.month}-${birthdate.day}`),
      indContactoDespues: 'NO',
      indPoliticaDatosPersonales: 'SI',
      fechaContacto: '',
      horaContacto: '',
    },
    asegurado: [
      {
        nombre: client.nombres,
        tipoDocumento: client.tipoDocumento === 4 ? 3 : 2,
        numeroDocumento: client.numeroDocumento,
        tipoAsegurado: 'titular',
        correo: mail,
        celular: client.telefono,
        edad: calculateAge(`${birthdate.year}-${birthdate.month}-${birthdate.day}`),
      },
    ],
  };
};

export const formatRequestQuote = (insureds) => insureds.map((insured) => ({
  parentesco: insured.relationship,
  edad: insured.age,
}));
